import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { EmptyValuePlaceholder, Pagination, Textarea, Spinner } from '@/components/ui'
import { formatDate } from '@/utils/formatters'
import { useBienContext } from "@/features/biens/BienContext"
import { fetchVisites } from '@/features/visites/visitesSlice'

const VisiteItem = ({item}) => {

  return (
    <div>
      <p>
        Visite réalisée le <EmptyValuePlaceholder value={formatDate(item.date_visite)} />
      </p>
    </div>
  )
}

export default () => {
  const dispatch = useDispatch()
  const { bien } = useBienContext()
  const visites = useSelector( state => state.visites.items )
  const loading = useSelector( state => state.visites.loadingStatus.fetchList )
  const pagination = useSelector( state => state.visites.pagination) 

  useEffect(
    () => {
      if(visites.length == 0 && bien?.id) {
        dispatch(fetchVisites({bien_id: bien.id}))
      }
    },
    [bien?.id]
  ) 

  const handlePageChange = (page) => {
    dispatch(fetchVisites({bien_id: bien.id, page: page}))
  } 

  return (
    <div className="h-full">
      <h3 className="text-md font-semibold mb-2">
        Visites
      </h3>
      <div className="bg-primary-100 p-4 rounded-none"> 
        { loading && <Spinner /> }
        { !loading && <div className="join join-vertical w-full"> 
            { visites.length == 0 ? 
              <p className="col-span-2 text-center">Aucune visite</p> :
              visites.map( item => <VisiteItem key={item.id} item={item} />)
            }
        </div> }
        { pagination && pagination.totalPages > 1 && 
          <Pagination 
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={handlePageChange}
          />
        }
      </div>
    </div>
  )

}